import _get from 'lodash/get'
import CamundaAPIClient from '@/clients/camundaApi'
import _each from 'lodash/each'


const Service = {
    deserializeInstanceVariables(variables) {
        let deserialized = {};

        _each(variables, (variable, key) => {
            switch (variable.type) {
                case "Json":
                    try {
                        variable.value = JSON.parse(variable.value);
                    } catch (e) {
                        console.log(e);
                    }
                    break;
            }
            deserialized[key] = variable;
        });

        return deserialized;
    },
    encodeVariable(value) {
        let variableValue = {};

        switch (typeof value) {
            case 'boolean':
                variableValue.type = 'boolean';
                variableValue.value = value;
                break;
            case 'string':
                variableValue.type = 'string';
                variableValue.value = value;
                break;
            case 'number':
                variableValue.type = 'integer';
                variableValue.value = value;
                break;
            case 'object':
                if(value !== null) { //verify that value is not null - in JavaScript, the data type of null is an object
                    if (value.hasOwnProperty('fileData')) {
                        variableValue.type = 'file';
                        variableValue.value = value.fileData;
                        variableValue.valueInfo = {
                            filename: _get(value, 'fileName'),
                            mimeType: _get(value, 'fileMimeType')
                        };
                    } else {
                        variableValue.type = 'json';
                        variableValue.value = JSON.stringify(value);
                    }
                }
                break;
        }

        return variableValue;
    },
    getFilters() {
        return CamundaAPIClient.getFilters()
            .then((res) => {
                return res.data;
            });
    },
    getFilterTasks(filterId, query) {
        return CamundaAPIClient.getFilterTasks(filterId, query)
            .then((res) => {
                let tasks = _get(res, 'data._embedded.task', []);

                tasks = tasks.map((task) => {
                    let variables = _get(task, '_embedded.variable', []);
                    variables = this.deserializeInstanceVariables(variables);
                    task.variables = variables;

                    return task;
                });

                return tasks;
            });
    },
    getTasks(filter) {
        return CamundaAPIClient.getTasks(filter)
            .then((res) => {
                return res.data;
            });
    },
    getFilterTasksCount(filterId) {
        return CamundaAPIClient.getFilterTasksCount(filterId)
            .then((res) => {
                return res.data;
            });
    },
    getTasksCount(filter) {
        return CamundaAPIClient.getTasksCount(filter)
            .then((res) => {
                return res.data;
            });
    },
    getProcessDefinitionByKey(processKey) {
        return CamundaAPIClient.getProcessDefinitionByKey(processKey)
            .then((res) => {
                return res.data;
            });
    },
    claimTask(taskId, userId) {
        return CamundaAPIClient.claimTask(taskId, userId)
            .then((res) => {
                return res.data;
            });
    },
    unclaimTask(taskId) {
        return CamundaAPIClient.unclaimTask(taskId)
            .then((res) => {
                return res.data;
            });
    },
    getTask(taskId) {
        return CamundaAPIClient.getTask(taskId)
            .then((res) => {
                return res.data;
            });
    },
    getTaskForm(taskId) {
        return CamundaAPIClient.getTaskForm(taskId)
            .then((res) => {
                return res.data;
            });
    },
    getProcessStartFormKey(definitionId) {
        return CamundaAPIClient.getProcessStartFormKey(definitionId)
            .then((res) => {
                return res.data;
            });
    },
    startProcessInstanceId(definitionId, body = {}) {
        return CamundaAPIClient.startProcessInstanceId(definitionId, body)
            .then((res) => {
                return res.data;
            });
    },
    startProcessInstanceKey(definitionKey, body = {}) {
        return CamundaAPIClient.startProcessInstanceKey(definitionKey, body)
            .then((res) => {
                return res.data;
            });
    },
    uploadBatchOrderFile(file, templateName, paymentBy, limitPerOrder = 1000) {
        return CamundaAPIClient.uploadBatchOrderFile(file, limitPerOrder, paymentBy, templateName)
            .then((res) => {
                return res.data;
            });
    },
    getDeploymentResources(deploymentId) {
        return CamundaAPIClient.getDeploymentResources(deploymentId)
            .then((res) => {
                return res.data;
            });
    },
    getDeploymentResourceData(deploymentId, resourceId) {
        return CamundaAPIClient.getDeploymentResourceData(deploymentId, resourceId)
            .then((res) => {
                return res.data;
            });
    },
    findProcessInstanceFromHistory(query) {
        return CamundaAPIClient.findProcessInstanceFromHistory(query)
            .then((res) => {
                return res.data;
            });
    },
    findProcessInstance(query) {
        return CamundaAPIClient.findProcessInstance(query)
            .then((res) => {
                return res.data;
            });
    },
    getProcessInstance(instanceID) {
        return CamundaAPIClient.getProcessInstance(instanceID)
            .then((res) => {
                return res.data;
            });
    },
    getProcessInstanceHistory(instanceID) {
        return CamundaAPIClient.getProcessInstanceHistory(instanceID)
            .then((res) => {
                return res.data;
            });
    },
    getProcessInstanceVariables(instanceID) {
        return CamundaAPIClient.getProcessInstanceVariables(instanceID)
            .then((res) => {
                return res.data;
            });
    },
    getProcessInstanceTasks(instanceID) {
        return CamundaAPIClient.getProcessInstanceTasks(instanceID)
            .then((res) => {
                return res.data;
            });
    },
    postTaskForm(taskId, body) {
        return CamundaAPIClient.postTaskForm(taskId, body)
            .then((res) => {
                return res.data;
            });
    },
    postMessage(messageName, processInstanceId, processVariables) {
        return CamundaAPIClient.postMessage({
            messageName: messageName,
            processInstanceId: processInstanceId,
            processVariables: processVariables
        })
            .then((res) => {
                return res.data;
            });
    },
    getBatchOrderFileInstance(instanceID) {
        /*
{
"links": [
{
    "method": "GET",
    "href": "http://localhost:8081/rest/engine/default/process-instance/74431f22-4457-11e9-b936-0242ac110002",
    "rel": "self"
}
],
"id": "74431f22-4457-11e9-b936-0242ac110002",
"definitionId": "UploadFiles:1:fe7a032f-441d-11e9-b936-0242ac110002",
"businessKey": null,
"caseInstanceId": null,
"ended": false,
"suspended": false,
"tenantId": null
}
 */

    }
};

export default Service;
